export default __webpack_public_path__ + "static/media/image.study-tree.b2c4880e.png";